import { render, staticRenderFns } from "./Checklist.vue?vue&type=template&id=3918968e&"
import script from "./Checklist.vue?vue&type=script&lang=ts&"
export * from "./Checklist.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports